import React from 'react';

// Components
import TablaClientes from '../../components/clientes/TablaClientes';

const ClientesSection = () => {

    return (
        <div>
            <TablaClientes />
        </div>        
    );
};

export default ClientesSection;